import { render, staticRenderFns } from "./AddESGDataLog.vue?vue&type=template&id=bdfc798e"
import script from "./AddESGDataLog.vue?vue&type=script&lang=js"
export * from "./AddESGDataLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports